var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col s2"},[_vm._v(_vm._s(_vm.rank + 1))]),_c('div',{staticClass:"col s7"},[_vm._v(_vm._s(_vm.team))]),_c('div',{staticClass:"col s3"},[_vm._v(_vm._s(Math.trunc(_vm.score)))])])}
var staticRenderFns = []

export { render, staticRenderFns }